import history from "@history.js";
import jwtAuthService from "../../services/jwtAuthService";

export const SET_USER_DATA = "USER_SET_DATA";
export const REMOVE_USER_DATA = "USER_REMOVE_DATA";
export const USER_LOGGED_OUT = "USER_LOGGED_OUT";

export function setUserData(user) {
  return (dispatch) => {
    dispatch({
      type: SET_USER_DATA,
      data: user,
    });
  };
}

export function logoutUser() {
  return (dispatch) => {
    var sessionType = localStorage.getItem("sessionType");
    var pathName =
      sessionType === "0" ? "/app/session/signin" : "/app/users/login";
    jwtAuthService.logout();

    history.push({
      pathname: pathName,
    });

    dispatch({
      type: USER_LOGGED_OUT,
    });
  };
}
